import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
    selector: 'app-cookie',
    templateUrl: './cookie.component.html',
    styleUrls: ['./cookie.component.css']
})
export class CookieComponent implements OnInit, OnDestroy {

  showBanner = false;
  private readonly STORAGE_KEY = 'cookieConsent';
  private timeoutId: ReturnType<typeof setTimeout> | undefined;

  ngOnInit(): void {
    if (!localStorage.getItem(this.STORAGE_KEY)) {
      this.showBanner = true;
      this.timeoutId = setTimeout(() => this.dismiss(), 20000);
    }
  }

  ngOnDestroy(): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  dismiss(): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    localStorage.setItem(this.STORAGE_KEY, 'dismissed');
    this.showBanner = false;
  }
}
